const PRODUCTION_API_URL = 'https://service-core.angellistindia.com/graphql';
const STAGING_API_URL = 'https://staging-api.angellistindia.com/graphql';
const DEVELOPMENT_API_URL = 'http://localhost:8000/graphql';

const PREVIEW_API_URL = 'https://preview-unit-transfers-369599305565.asia-south1.run.app/graphql';

export const getServiceEndpoint = () => {
  switch (process.env.REACT_APP_MODE) {
    case 'production':
      return PRODUCTION_API_URL;
    case 'staging':
      return STAGING_API_URL;
    case 'preview':
      return PREVIEW_API_URL ? PREVIEW_API_URL : STAGING_API_URL;
    case 'development':
      return DEVELOPMENT_API_URL;
    default:
      return PRODUCTION_API_URL;
  }
};

export const getInternalServiceEndpoint = () => {
  const INTERNAL_IDENTIFIER = process.env.INTERNAL_IDENTIFIER;
  if (!INTERNAL_IDENTIFIER) {
    return process.env.INTERNAL_GRAPHQL_BACKEND;
  }
  switch (process.env.REACT_APP_MODE) {
    case 'production':
      return `${PRODUCTION_API_URL}-${INTERNAL_IDENTIFIER}`;
    case 'staging':
      return `${STAGING_API_URL}-${INTERNAL_IDENTIFIER}`;
    case 'preview':
      return `${PREVIEW_API_URL ? PREVIEW_API_URL : STAGING_API_URL}-${INTERNAL_IDENTIFIER}`;
    case 'development':
      return `${DEVELOPMENT_API_URL}-${INTERNAL_IDENTIFIER}`;
    default:
      return `${PRODUCTION_API_URL}-${INTERNAL_IDENTIFIER}`;
  }
};
